import { FC } from 'react';

export const ChevronDown: FC<{className: string}> = ({ className }) => (
  <svg className={className} width="25" height="14" viewBox="0 0 25 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M23.6841 1L12.3703 12.3137L1.05664 1" stroke="black" strokeWidth="2" />
  </svg>
);
